const DRAUGHT_EPSILON = 0.001;

const formatDecimal = (value, fallback = '0.00') => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return fallback;
  }
  return numeric.toFixed(2);
};

export const draughtsDiffer = (maxDraught, realDraught) => {
  if (maxDraught == null || realDraught == null || realDraught === '') {
    return false;
  }
  const max = Number(maxDraught);
  const real = Number(realDraught);
  if (!Number.isFinite(max) || !Number.isFinite(real)) {
    return false;
  }
  return Math.abs(max - real) > DRAUGHT_EPSILON;
};

/**
 * Current draught (max_draught), with nautical draught at chart zero when different.
 * Example: "1.55 (0.94 bei Kartennull)"
 */
export const formatDraughtDisplay = (
  maxDraught,
  realDraught,
  atChartZeroLabel,
  fallback = '0.00',
) => {
  const maxFormatted = formatDecimal(maxDraught, fallback);
  if (!draughtsDiffer(maxDraught, realDraught)) {
    return maxFormatted;
  }
  const realFormatted = formatDecimal(realDraught, fallback);
  return `${maxFormatted} (${realFormatted} ${atChartZeroLabel})`;
};

/**
 * L / B / T with optional nautical draught note on T.
 * Example: "11.00 / 4.00 / 1.55 (0.94 bei Kartennull)"
 */
export const formatMooringLBT = (mooring, atChartZeroLabel, fallback = '0.00') => {
  if (!mooring) {
    return `${fallback} / ${fallback} / ${fallback}`;
  }
  const length = formatDecimal(mooring.max_length, fallback);
  const beam = formatDecimal(mooring.max_beam, fallback);
  const draught = formatDraughtDisplay(
    mooring.max_draught,
    mooring.real_draught,
    atChartZeroLabel,
    fallback,
  );
  return `${length} / ${beam} / ${draught}`;
};
